export type TgLanguageCodes = 'en' | 'ru' | 'uk';
export type I18NLanguageCodes = 'en-US' | 'ru-RU' | 'uk-UK';

export const i18nLanguageCodes: Record<TgLanguageCodes, I18NLanguageCodes> = {
  ru: 'ru-RU',
  uk: 'uk-UK',
  en: 'en-US'
};
